import React from 'react'
import { useSelector } from 'react-redux'

import { campaignSelector } from '../../../../../../modules/selectors/campaigns'

import { NAME } from '../../../../../Multiplatform/CampaignForms/fields'

import useStyles from './styles'

function NameSectionPreview() {
  const classes = useStyles()

  const campaign = useSelector(campaignSelector)

  const { [NAME]: name } = campaign

  return <p className={classes.name}>{name}</p>
}

export default NameSectionPreview
